import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { HiringResourcesEffects } from './store/hiring-resources.effects';
import { HiringResourcesNamespace, HiringResourcesReducer } from './store/hiring-resources.store';

@NgModule({
  imports: [
    StoreModule.forFeature(HiringResourcesNamespace, HiringResourcesReducer),
    EffectsModule.forFeature([HiringResourcesEffects]),
  ],
})
export class TellentAssignMembersToJobsDataModule {}
